import { useMemo } from "react";
import { getCookieManager } from "../utils/cookieManagerUtils";

export const useGetCookieManager = () => {
    return useMemo(() => getCookieManager(), []);
};
